module.exports = __webpack_public_path__ + "static/media/162.796958fc.png";